import useSWR from "swr";
import { getCurrentMonthStats, getPreviousMonthStats } from "@/services/statistics.service";

export function useMonthlyUsageStats() {
  const current = useSWR("current-month-stats", getCurrentMonthStats, { refreshInterval: 60000 });
  const previous = useSWR("previous-month-stats", getPreviousMonthStats, { refreshInterval: 60000 });
  return {
    currentStats: current.data,
    previousStats: previous.data,
    error: current.error,
    previousError: previous.error,
    isLoading: !current.error && current.isLoading,
    previousLoading: !previous.error && previous.isLoading,
  };
}
